module.exports = __webpack_public_path__ + "/build/web/images/matching-pillows-option-piping.ece04607708abc669415d38f06d43c5f.png";


//////////////////
// WEBPACK FOOTER
// ./images/matching-pillows-option-piping.png
// module id = 170
// module chunks = 13